import { render, staticRenderFns } from "./Advantage.vue?vue&type=template&id=86bc7e36&scoped=true"
import script from "./Advantage.vue?vue&type=script&lang=js"
export * from "./Advantage.vue?vue&type=script&lang=js"
import style0 from "./Advantage.vue?vue&type=style&index=0&id=86bc7e36&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bc7e36",
  null
  
)

export default component.exports